import { FC } from "react";
import { UseFormReturn } from "react-hook-form";
import { MiDetailFields } from "@miplatform/components";
import { INPUT_TYPES } from "@miplatform/constants";
import { ConfigAccordionHeader } from "../../components/ConfigAccordionHeader/ConfigAccordionHeader";
import { IOrderTemplateForm } from "../ConfigOrderTemplates.types";

export const OrderSchedulingRulesTabView: FC<
  OrderSchedulingRulesTabViewProps
> = ({ form, extraTabProps: { isReadOnly } = {} }) => {
  const { control, watch, setValue } = form;
  const {
    expectedDurationInHours,
    maxTimesPutOnHold,
    scheduleTimeThreshold,
    allowableScheduleLimit,
    lockRescheduleThreshold,
    fulfillmentSequence,
  } = watch();

  const schedulingFields = [
    {
      label: "Estimated Total Duration (hours)",
      name: "expectedDurationInHours",
      formControl: control,
      fieldType: INPUT_TYPES.NUMERIC,
      suffix: Number(expectedDurationInHours) === 1 ? " hour" : " hours",
      width: "50%",
      InputProps: { inputProps: { maxLength: 10 } },
      value: expectedDurationInHours,
      setValue: (value: string) => {
        setValue("expectedDurationInHours", Number(value), {
          shouldValidate: true,
          shouldDirty: true,
        });
      },
      disabled: isReadOnly,
    },
    {
      label: "Max Hold Attempts",
      name: "maxTimesPutOnHold",
      formControl: control,
      fieldType: INPUT_TYPES.NUMERIC,
      width: "50%",
      value: maxTimesPutOnHold,
      InputProps: { inputProps: { maxLength: 4 } },
      decimalScale: 0,
      setValue: (value: string) => {
        setValue("maxTimesPutOnHold", Number(value), {
          shouldValidate: true,
          shouldDirty: true,
        });
      },
      disabled: isReadOnly,
    },
    {
      label: "Schedule Time Threshold (hours)",
      name: "scheduleTimeThreshold",
      formControl: control,
      fieldType: INPUT_TYPES.NUMERIC,
      suffix: Number(scheduleTimeThreshold) === 1 ? " hour" : " hours",
      width: "50%",
      InputProps: { inputProps: { maxLength: 10 } },
      value: scheduleTimeThreshold,
      setValue: (value: string) => {
        setValue("scheduleTimeThreshold", Number(value), {
          shouldValidate: true,
          shouldDirty: true,
        });
      },
    },
    {
      label: "Allowable Schedule Limit (hours)",
      name: "allowableScheduleLimit",
      formControl: control,
      fieldType: INPUT_TYPES.NUMERIC,
      suffix: Number(allowableScheduleLimit) === 1 ? " hour" : " hours",
      width: "50%",
      value: allowableScheduleLimit,
      InputProps: { inputProps: { maxLength: 9 } },
      decimalScale: 0,
      setValue: (value: string) => {
        setValue("allowableScheduleLimit", Number(value), {
          shouldValidate: true,
          shouldDirty: true,
        });
      },
    },
    {
      label: "Reschedule Lock Threshold",
      name: "lockRescheduleThreshold",
      formControl: control,
      fieldType: INPUT_TYPES.NUMERIC,
      value: lockRescheduleThreshold,
      width: "50%",
      InputProps: { inputProps: { maxLength: 4 } },
      setValue: (value: string) => {
        setValue("lockRescheduleThreshold", Number(value), {
          shouldValidate: true,
          shouldDirty: true,
        });
      },
    },
    {
      label: "Fulfillment Sequence",
      name: "fulfillmentSequence",
      fieldType: INPUT_TYPES.NUMERIC,
      width: "50%",
      decimalScale: 0,
      formControl: control,
      value: fulfillmentSequence,
      setValue: (value: string) => {
        setValue("fulfillmentSequence", Number(value), {
          shouldValidate: true,
          shouldDirty: true,
        });
      },
    },
  ];

  return (
    <ConfigAccordionHeader title="Scheduling Rules">
      <MiDetailFields detailFields={schedulingFields} />
    </ConfigAccordionHeader>
  );
};

interface OrderSchedulingRulesTabViewProps {
  form: UseFormReturn<IOrderTemplateForm>;
  extraTabProps?: {
    isReadOnly?: boolean;
  };
}
